var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );
dependencies["macros/product-image.j2"] = require( "macros/product-image.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/generic-slider.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/macros/generic-slider.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
env.getTemplate("macros/slider-macros.j2", false, "core/templates/macros/generic-slider.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("create_slider_arrows")) {
var t_8 = t_5.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_8);
env.getTemplate("macros/product-image.j2", false, "core/templates/macros/generic-slider.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("productImageSrc")) {
var t_12 = t_9.productImageSrc;
} else {
cb(new Error("cannot import 'productImageSrc'")); return;
}
context.setVariable("productImageSrc", t_12);
env.getTemplate("macros/urls.j2", false, "core/templates/macros/generic-slider.j2", false, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
t_13.getExported(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
if(t_13.hasOwnProperty("productUrl")) {
var t_16 = t_13.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_16);
if(t_13.hasOwnProperty("genericUrl")) {
var t_17 = t_13.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_17);
var macro_t_18 = runtime.makeMacro(
[], 
["items", "displayOverlayControls", "usePlaceholder"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("items", kwargs.hasOwnProperty("items") ? kwargs["items"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("displayOverlayControls", kwargs.hasOwnProperty("displayOverlayControls") ? kwargs["displayOverlayControls"] : runtime.contextOrFrameLookup(context, frame, "True"));
frame.set("usePlaceholder", kwargs.hasOwnProperty("usePlaceholder") ? kwargs["usePlaceholder"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_19 = "";t_19 += "\n    ";
var t_20;
t_20 = runtime.contextOrFrameLookup(context, frame, "isDy") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "items")),"isDy");
frame.set("isDynamicYield", t_20, true);
if(frame.topLevel) {
context.setVariable("isDynamicYield", t_20);
}
if(frame.topLevel) {
context.addExport("isDynamicYield", t_20);
}
t_19 += "\n    ";
var t_21;
t_21 = (lineno = 7, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isFeatureEnabled"), "isFeatureEnabled", context, [runtime.contextOrFrameLookup(context, frame, "core"),"favorites"])) && runtime.contextOrFrameLookup(context, frame, "displayOverlayControls");
frame.set("displayFavorites", t_21, true);
if(frame.topLevel) {
context.setVariable("displayFavorites", t_21);
}
if(frame.topLevel) {
context.addExport("displayFavorites", t_21);
}
t_19 += "\n    ";
var t_22;
t_22 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "items")),"placement");
frame.set("trayPlacement", t_22, true);
if(frame.topLevel) {
context.setVariable("trayPlacement", t_22);
}
if(frame.topLevel) {
context.addExport("trayPlacement", t_22);
}
t_19 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "usePlaceholder") && !runtime.contextOrFrameLookup(context, frame, "items")) {
t_19 += "\n\n        ";
var t_23;
t_23 = (lineno = 12, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getScene7ImagePath"), "getScene7ImagePath", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty")]));
frame.set("imageUrl", t_23, true);
if(frame.topLevel) {
context.setVariable("imageUrl", t_23);
}
if(frame.topLevel) {
context.addExport("imageUrl", t_23);
}
t_19 += "\n        ";
var t_24;
t_24 = (lineno = 13, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.thirdParty.default.scene7.tile_placeholder_image_small","image-unavailable-small"]));
frame.set("placeholderSlug", t_24, true);
if(frame.topLevel) {
context.setVariable("placeholderSlug", t_24);
}
if(frame.topLevel) {
context.addExport("placeholderSlug", t_24);
}
t_19 += "\n        ";
var t_25;
t_25 = Math.floor(12 / (lineno = 14, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.thirdParty.default.rich_relevance.slide_count_for_medium",6])));
frame.set("mediumColumnWidth", t_25, true);
if(frame.topLevel) {
context.setVariable("mediumColumnWidth", t_25);
}
if(frame.topLevel) {
context.addExport("mediumColumnWidth", t_25);
}
t_19 += "\n\n        <div class=\"o-slider-placeholder\">\n\n            <div class=\"o-slider-placeholder__wrapper o-medium--";
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "mediumColumnWidth"), env.opts.autoescape);
t_19 += " o-large--2\">\n\n                <img class=\"o-slider-placeholder__image\" src=\"";
t_19 += runtime.suppressValue((lineno = 20, colno = 77, runtime.callWrap(t_12, "productImageSrc", context, [runtime.contextOrFrameLookup(context, frame, "imageUrl"),runtime.contextOrFrameLookup(context, frame, "placeholderSlug")])), env.opts.autoescape);
t_19 += "\" alt=\"";
t_19 += runtime.suppressValue((lineno = 20, colno = 113, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_pdp_banner_alt_text"])), env.opts.autoescape);
t_19 += "\" />\n\n            </div>\n\n        </div>\n\n    ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "items")) {
t_19 += "<div class=\"o-row ";
t_19 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isDynamicYield")?"js-dy-recommendations":""), env.opts.autoescape);
t_19 += "\">\n\n            <div class=\"o-column o-extra-small--12 o-slider-product-tray__wrapper js-rr-placement-";
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "trayPlacement"), env.opts.autoescape);
t_19 += "\">\n\n                <div class=\"o-slider-product-tray o-slider-product-tray--product-image js-slider--product-image\">\n\n                    <div class=\"o-slider-product-tray__inner js-slider-product-tray__inner\">";
frame = frame.push();
var t_28 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "items")),"recs");
if(t_28) {var t_27 = t_28.length;
for(var t_26=0; t_26 < t_28.length; t_26++) {
var t_29 = t_28[t_26];
frame.set("item", t_29);
frame.set("loop.index", t_26 + 1);
frame.set("loop.index0", t_26);
frame.set("loop.revindex", t_27 - t_26);
frame.set("loop.revindex0", t_27 - t_26 - 1);
frame.set("loop.first", t_26 === 0);
frame.set("loop.last", t_26 === t_27 - 1);
frame.set("loop.length", t_27);
var t_30;
t_30 = runtime.memberLookup((t_29),"product");
frame.set("product", t_30, true);
if(frame.topLevel) {
context.setVariable("product", t_30);
}
if(frame.topLevel) {
context.addExport("product", t_30);
}
t_19 += "\n                        ";
var t_31;
t_31 = (lineno = 41, colno = 53, runtime.callWrap(t_16, "productUrl", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"productSlug"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"queryParams")]));
frame.set("productLink", t_31, true);
if(frame.topLevel) {
context.setVariable("productLink", t_31);
}
if(frame.topLevel) {
context.addExport("productLink", t_31);
}
t_19 += "\n                        ";
var t_32;
t_32 = (runtime.contextOrFrameLookup(context, frame, "product")?(lineno = 42, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","rec tray " + runtime.contextOrFrameLookup(context, frame, "trayPlacement") + " | " + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") + " | " + "click",runtime.contextOrFrameLookup(context, frame, "productLink")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("recAnalytics", t_32, true);
if(frame.topLevel) {
context.setVariable("recAnalytics", t_32);
}
if(frame.topLevel) {
context.addExport("recAnalytics", t_32);
}
t_19 += "\n\n                        <div class=\"o-slider-product-tray__slide o-slider-product-tray__slide--product-image js-slider-product-tray__slide\">\n\n                            ";
t_19 += runtime.suppressValue((lineno = 46, colno = 47, runtime.callWrap(t_4, "displayProductTile", context, [runtime.contextOrFrameLookup(context, frame, "product"),runtime.makeKeywordArgs({"tileTemplate": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "items")),"tileTemplate"),"productIndex": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"displayOverlayControls": runtime.contextOrFrameLookup(context, frame, "displayOverlayControls"),"analytics": runtime.contextOrFrameLookup(context, frame, "recAnalytics"),"displayFavorites": runtime.contextOrFrameLookup(context, frame, "displayFavorites")})])), env.opts.autoescape);
t_19 += "\n                        </div>";
;
}
}
frame = frame.pop();
t_19 += "</div>\n\n                </div>\n\n                ";
var t_33;
t_33 = env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "items")),"recs")) > runtime.contextOrFrameLookup(context, frame, "slidesPerView");
frame.set("showSliderArrows", t_33, true);
if(frame.topLevel) {
context.setVariable("showSliderArrows", t_33);
}
if(frame.topLevel) {
context.addExport("showSliderArrows", t_33);
}
t_19 += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showSliderArrows")) {
t_19 += "\n\n                    ";
t_19 += runtime.suppressValue((lineno = 59, colno = 41, runtime.callWrap(t_8, "create_slider_arrows", context, [runtime.makeKeywordArgs({"disablePrev": runtime.contextOrFrameLookup(context, frame, "True"),"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
t_19 += "\n\n                ";
;
}
t_19 += "\n\n            </div>\n\n        </div>";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
context.addExport("genericSlider");
context.setVariable("genericSlider", macro_t_18);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/generic-slider.j2"] , dependencies)